import styled from 'styled-components';

export const PrContainer = styled.div`
  display: flex;
  min-height: 45vh;
  margin-top: 30px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
  justify-content: space-between;
`;

export const SectionPartition = styled.span`
  position: absolute;
  width: 200px;
  border-bottom: 1px solid #dadada;
  top: 40%;
  transform: rotate(90deg);
  height: 1px;
  left: 38%;
  z-index: 200;
  @media (max-width: 720px) {
    display: none;
  }
`;
